import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { orderPreferencesValidationSchema } from '../tabs/OrderPreferencesTab/validation/orderPreferencesValidation';
import { SupplierFormData } from '../types';

const validateRequiredString = (value: string | undefined | null): boolean =>
  Boolean(value?.trim());

export const supplierFormValidationSchema = yup
  .object()
  .shape({
    name: yup
      .string()
      .test('nameRequired', 'Company name is required', validateRequiredString)
      .required('Company name is required'),
    description: yup.string().optional(),
    primaryCategory: yup
      .string()
      .test(
        'primaryCategoryRequired',
        'Primary category is required',
        validateRequiredString
      )
      .required('Primary category is required'),
    secondaryCategories: yup.array().of(yup.string()).default([]),
    deliveryFee: yup.string().optional(), // TODO: Add numeric validation
    minimumOrderValue: yup.string().optional(), // TODO: Add numeric validation
    minimumOrderCurrency: yup.string().optional().default('EUR'),
  })
  .concat(
    orderPreferencesValidationSchema
  ) as yup.ObjectSchema<SupplierFormData>;

export const supplierFormResolver = yupResolver<SupplierFormData>(
  supplierFormValidationSchema
);
